import { SurveyModel, SurveyQuestionJson } from "@performyard/service-contracts";

export const SURVEY_DETAILS_MODALS = {
	PUBLISH_SURVEY: "publish-survey",
	PUBLISH_SURVEY_SUCCESS: "publish-survey-success",
	PUBLISH_SURVEY_INVALID: "publish-survey-invalid",
	SAVE_AS_COPY: "save-as-copy",
	DELETE_SURVEY: "delete-survey",
	CLOSE_SURVEY: "close-survey",
	SHARE_SURVEY: "share-survey",
	SHARE_SURVEY_CONFIRMATION: "share-survey-confirmation",
	SURVEY_SETTINGS: "survey-settings",
	EDIT_SURVEY_SCHEDULE: "edit-survey-schedule",
	SELECT_ALL_EMPLOYEES_MODAL: "select-all-employees-modal",
	NO_PARTICIPANTS_SELECTED_MODAL: "no-participants-selected-modal",
} as const;

export type SurveyDetailsModal = (typeof SURVEY_DETAILS_MODALS)[keyof typeof SURVEY_DETAILS_MODALS];

interface SurveyDetailsSetters {
	setSurveyStatus: (surveyStatus: SurveyModel["status"] | null) => void;
	setModal: (modal: SurveyDetailsModal | null) => void;
	setValidQuestions: (validQuestions: SurveyQuestionJson[]) => void;
	setValidName: (validName: string) => void;
	setSurveyLink: (surveyLink: string) => void;
}

export interface SurveyDetailsStore {
	surveyStatus: SurveyModel["status"] | null;
	modal: SurveyDetailsModal | null;
	validQuestions: SurveyQuestionJson[];
	validName: string;
	surveyLink: string;
	setters: SurveyDetailsSetters;
}
